(function () {
    'use strict';

    angular
        .module('ib-http-services-module')
        .factory('UserLoggedBookingProxy', UserLoggedBookingProxy);

    UserLoggedBookingProxy.$inject = ['$http', '$q'];
    function UserLoggedBookingProxy($http, $q) {

        return {
            getUserLoggedBookingInformation: getUserLoggedBookingInformation
        };

        ////////////////
        /**
         * @function 
         * @name getUserLoggedBookingInformation
         * @desc REST service call to get the booking information requested by the user using HTTP GET method
         */
        function getUserLoggedBookingInformation(uri) {
            return $http.get(uri).then(getUserLoggedBookingInformationComplete)['catch'](getUserLoggedBookingInformationFailed);

            function getUserLoggedBookingInformationComplete(response) {
                return response.data;
            }

            function getUserLoggedBookingInformationFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();